"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationRule = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const lodash_1 = require("lodash");
const form_autocomplete_1 = require("../../composite/form/fields/form-autocomplete");
const form_panel_1 = require("../../composite/form/fields/form-panel");
const form_select_1 = require("../../composite/form/fields/form-select");
const form_table_field_1 = require("../../composite/form/fields/form-table-field");
const form_context_1 = require("../../composite/form/form-context");
const selector_1 = require("../../composite/form/selectors/selector");
const table_field_cells_1 = require("../../components/table-field/table-field-cells");
const notification_template_api_1 = require("./notification-template-api");
const notification_template_context_1 = require("./notification-template-context");
const notification_template_types_1 = require("./notification-template-types");
function NotificationRule({ prefix = '' }) {
    const prefixed = prefix ? `${prefix}.` : '';
    const columns = useColumns();
    const { useUsers, useRoles } = (0, react_1.useContext)(notification_template_context_1.NotificationTemplateContext);
    const { setFieldValue } = (0, react_1.useContext)(form_context_1.FormContext);
    const { rule } = (0, selector_1.useFormSelector)((data) => ({
        rule: (0, lodash_1.get)(data, prefix, data),
    }));
    const ruleTypes = (0, notification_template_api_1.useNotificationRules)();
    const users = useUsers === null || useUsers === void 0 ? void 0 : useUsers();
    const roles = useRoles === null || useRoles === void 0 ? void 0 : useRoles();
    return (react_1.default.createElement(form_panel_1.FormPanel, { label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_NOTIFICATION_TEMPLATES_RULE_PANEL_TITLE", defaultMessage: "Pravidlo" }), expandable: false },
        react_1.default.createElement(form_select_1.FormSelect, { name: `${prefixed}id`, source: ruleTypes, label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_NOTIFICATION_TEMPLATES_RULE_LABEL_TYPE", defaultMessage: "Typ" }), notifyChange: () => setFieldValue(`${prefixed}value`, undefined), valueIsId: true }),
        rule.id === notification_template_types_1.RuleType.ROLE_RULE && roles && (react_1.default.createElement(form_autocomplete_1.FormAutocomplete, { source: roles, name: `${prefixed}value`, label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_NOTIFICATION_TEMPLATES_RULE_LABEL_ROLES", defaultMessage: "Role" }), multiple: true })),
        rule.id === notification_template_types_1.RuleType.USER_RULE && users && (react_1.default.createElement(form_autocomplete_1.FormAutocomplete, { source: users, name: `${prefixed}value`, label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_NOTIFICATION_TEMPLATES_RULE_LABEL_USERS", defaultMessage: "U\u017Eivatel\u00E9" }), multiple: true })),
        (rule.id === notification_template_types_1.RuleType.AND_RULE || rule.id === notification_template_types_1.RuleType.OR_RULE) && (react_1.default.createElement(form_table_field_1.FormTableField, { name: `${prefixed}value`, label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_NOTIFICATION_TEMPLATES_RULE_LABEL_RULES", defaultMessage: "Pravidla" }), columns: columns, FormFieldsComponent: () => (react_1.default.createElement("div", { style: { width: 800 } },
                react_1.default.createElement(NotificationRule, null))), initNewItem: () => ({}) }))));
}
exports.NotificationRule = NotificationRule;
function useColumns() {
    const intl = (0, react_intl_1.useIntl)();
    return [
        {
            datakey: 'id',
            name: intl.formatMessage({
                id: 'EAS_NOTIFICATION_TEMPLATES_RULE_COLUMN_ID',
                defaultMessage: 'Název',
            }),
            width: 200,
            CellComponent: table_field_cells_1.TableFieldCells.useSelectCellFactory(notification_template_api_1.useNotificationRules),
        },
        {
            datakey: 'value',
            name: intl.formatMessage({
                id: 'EAS_NOTIFICATION_TEMPLATES_RULE_COLUMN_VALUE',
                defaultMessage: 'Hodnota',
            }),
            width: 500,
            CellComponent: function Cell(props) {
                const label = createLabel(props.rowValue.id, props.value);
                return react_1.default.createElement(table_field_cells_1.TableFieldCells.TextCell, { ...props, value: label });
            },
        },
    ];
}
const createLabel = (id, value) => {
    if (id === notification_template_types_1.RuleType.ROLE_RULE || id === notification_template_types_1.RuleType.USER_RULE) {
        return value.map((val) => val.name).join(', ');
    }
    if (id === notification_template_types_1.RuleType.OR_RULE || id === notification_template_types_1.RuleType.AND_RULE) {
        return value
            .map((item) => {
            if (item.id === notification_template_types_1.RuleType.ROLE_RULE) {
                return `Role - ${createLabel(item.id, item.value)}`;
            }
            if (item.id === notification_template_types_1.RuleType.USER_RULE) {
                return `Uživatelé - ${createLabel(item.id, item.value)}`;
            }
            if (item.id === notification_template_types_1.RuleType.AND_RULE) {
                return `A ZÁROVEŇ (${createLabel(item.id, item.value)})`;
            }
            if (item.id === notification_template_types_1.RuleType.OR_RULE) {
                return `A NEBO (${createLabel(item.id, item.value)})`;
            }
            return createLabel(item.id, item.value);
        })
            .join('; ');
    }
    return '';
};
//# sourceMappingURL=notification-rule-fields.js.map